var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "box",
    attrs: {
      title: _vm.$t("人员录入"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 1000,
      height: 1000,
      maskClosable: false
    },
    on: {
      cancel: _vm.cancel
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 15
      },
      rules: _vm.rules
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单号"),
      prop: "policyNo"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  })], 1)], 1), _vm.policyPurpose === "other" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险方案"),
      prop: "insurancePlanName"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保险方案")
    },
    model: {
      value: _vm.form.insurancePlanName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insurancePlanName", $$v);
      },
      expression: "form.insurancePlanName"
    }
  })], 1)], 1) : _vm._e(), _vm.policyPurpose === "groupInsurance" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险方案"),
      prop: "insurancePlanCode"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: "请选择保险方案",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeInsurancePlan
    },
    model: {
      value: _vm.form.insurancePlanCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insurancePlanCode", $$v);
      },
      expression: "form.insurancePlanCode"
    }
  }, _vm._l(_vm.insurancePlan, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.mark
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险起期"),
      prop: "beginTime"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保险起期")
    },
    model: {
      value: _vm.form.beginTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "beginTime", $$v);
      },
      expression: "form.beginTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险止期"),
      prop: "endTime"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保险止期")
    },
    model: {
      value: _vm.form.endTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "endTime", $$v);
      },
      expression: "form.endTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险名称"),
      prop: "insuranceName"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保险名称")
    },
    model: {
      value: _vm.form.insuranceName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceName", $$v);
      },
      expression: "form.insuranceName"
    }
  })], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: "12"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("工种"),
      prop: "jobNumber"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("工种"),
      allowClear: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.form.jobNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "jobNumber", $$v);
      },
      expression: "form.jobNumber"
    }
  }, _vm._l(_vm.professionInfo, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.jobNumber
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.label
      }
    }, [_vm._v(" " + _vm._s(item.occupation) + " ")])], 1);
  }), 1)], 1)], 1), _vm.policyPurpose === "groupInsurance" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("工种类别"),
      prop: "occupationType"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      placeholder: _vm.$t("请输入") + _vm.$t("工种类别")
    },
    model: {
      value: _vm.form.occupationType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "occupationType", $$v);
      },
      expression: "form.occupationType"
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("姓名"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("姓名")
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "12"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件类型"),
      prop: "identificationType"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("证件类型"),
      getPopupContainer: triggerNode => triggerNode.parentNode,
      allowClear: ""
    },
    model: {
      value: _vm.form.identificationType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "identificationType", $$v);
      },
      expression: "form.identificationType"
    }
  }, _vm._l(_vm.identificationTypeData, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "12"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件号码"),
      prop: "idNumber"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("证件号码")
    },
    model: {
      value: _vm.form.idNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "idNumber", $$v);
      },
      expression: "form.idNumber"
    }
  })], 1)], 1), _vm.policyPurpose === "groupInsurance" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: "劳动合同单位（共同被保险人）",
      prop: "contractCompany"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "请输入劳动合同单位（共同被保险人）"
    },
    model: {
      value: _vm.form.contractCompany,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contractCompany", $$v);
      },
      expression: "form.contractCompany"
    }
  })], 1)], 1) : _vm._e(), _vm.policyPurpose === "groupInsurance" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: "实际工作单位（派遣单位）",
      prop: "dispatchCompany"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "请输入实际工作单位（派遣单位）"
    },
    model: {
      value: _vm.form.dispatchCompany,
      callback: function ($$v) {
        _vm.$set(_vm.form, "dispatchCompany", $$v);
      },
      expression: "form.dispatchCompany"
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("责任起期"),
      prop: "startAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      disabled: "",
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      placeholder: _vm.$t("请输入") + _vm.$t("责任起期")
    },
    model: {
      value: _vm.form.startAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "startAt", $$v);
      },
      expression: "form.startAt"
    }
  })], 1)], 1), _vm.policyPurpose === "other" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保费"),
      required: "",
      help: !_vm.form.startAt ? _vm.$t("选择责任起期后进行保费计算") : ""
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%",
      "margin-top": "1px"
    },
    attrs: {
      size: "default",
      disabled: "",
      readOnly: true
    },
    model: {
      value: _vm.form.premium,
      callback: function ($$v) {
        _vm.$set(_vm.form, "premium", $$v);
      },
      expression: "form.premium"
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      size: "default",
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      allowClear: ""
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap",
      "margin-top": "15px"
    }
  }, [_c("a-col", {
    staticClass: "btnBox",
    attrs: {
      span: 24
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };